enum ReusedPasswordEnum {
  IsReusedByUser = 'isReusedByUser',
  IsReusedByOrganization = 'isReusedByOrganization',
}

export default ReusedPasswordEnum;
